import React, {Component} from 'react'
import {authenticationService} from '../../../services/AuthenticationService';
import Config from "../../../config/Config";
import SvGraphics from "../../../assets/SvGraphics";
import Error from "../../../components/single_components/Error";
import * as Yup from "yup";
import validationHelper from "../../../utils/validationHelper";
import utils from "../../../utils/utils";
import Constants from "../../../utils/constants";
import AlertConfirm from "../../../components/modals/Confirm";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import ReCaptcha from "../ReCaptcha";

class ResetPasswordComposed extends Component {
    constructor(props) {
        super(props);
        this.recaptchaRef = React.createRef()

        this.state = {
            username:'',
            auth:{},
            isErr:false,
            errMessage:'',
            errors: {},
            errorsOnSave:{},
        }
    }

    initValidation = async () => {
        let {t} = this.props
        let validationSchema = Yup.object().shape({
            username:Yup.string().matches(Constants.emailRegExp, t('defaults.rst_pwd.username_inv')).required(t('defaults.rst_pwd.username_req'))})
        let errors = await validationHelper.validate(this.state.auth,validationSchema)
        await this.setState({
            validationSchema,
            errors
        })
    }

    async componentWillMount() {
        await this.initValidation()
    }

    goBack(){
        this.props.history.push('/login')

    }
      onSubmit = async () => {
        let isLocal = process.env.REACT_APP_ENV === 'localhost'

        if(!isLocal){
            await this.recaptchaRef.reset()
            await this.recaptchaRef.execute()
        }else{
            await this.submitData("NOTOKENINLOCAL");
        }

    }
    submitData = async (reCaptchaToken) => {
        let {t}=this.props
        if (!utils.isEmpty(this.state.errors)){
            this.setState({errorsOnSave:this.state.errors});
            return;
        }
        let {username} = this.state
        let response = await authenticationService.resetPassword(username,reCaptchaToken);
        if (response.status < 400) {
            let confirm = await AlertConfirm({
                options:{
                    title: t('defaults.rst_pwd.pwd_rst'),
                    cancelLabel: 'none',
                    proceedLabel: t('defaults.rst_pwd.Ok')
                }},`${t('defaults.rst_pwd.new_pwd_sent')}: ${username}`)
            if (confirm) {
                this.goBack()
            }
        } else {
            this.setState({
                isErr:true,
                errMessage:response.data.message,
                username: '',
                password: '',
                auth: {}
            })
        }
    }

    setUserName = async (e) => {
        let {auth,validationSchema} = this.state
        this.setState({username:e.target.value,isErr:false})
        utils.set(auth,'username',e.target.value)
        let errors = await validationHelper.validate(auth, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;
        if (utils.get(errorsOnSave,'username')){
            utils.set(errorsOnSave,'username',utils.get(errors,'username'))
        }
        this.setState({
            auth,
            errors,
            errorsOnSave
        })
    }


    render() {
        let {t} = this.props
        return (
            <div className={"login-page"}>
                <div className={'sade-login-logo-container'}>
                    <SvGraphics svgname={'asaya_logo'} className={'sade-asaya-login-logo'}/>
                </div>
                <div className={'sade-login-main-board'}>
                    <label className={'sade-login-label-reset-Leumit'}>{t('defaults.rst_pwd.rst_pwd')}</label>
                    <div className={'sade-login-form-container-reg'}>
                        <div className={'sade-Pain-login-form'}>
                            <div>
                                <div className={"login-input-wrapper form-group leumit-login-form-group"}>
                                    <input className={"sade-registration-input-field"}
                                           placeholder={t('defaults.rst_pwd.username')}
                                           type={"text"}
                                           name={"Username"}
                                           id={"search"}
                                           onChange={e => this.setUserName(e)} />
                                    <SvGraphics
                                        className={!!utils.get(this.state.errorsOnSave, 'username') ? "input-pic2" : "input-pic"}
                                        svgname={'person'}
                                        style={{width: '20px', height: '20px'}}/>
                                </div>
                                <Error isNonFloat={true}
                                       errorMessage={utils.get(this.state.errorsOnSave, 'username')}
                                       isShown={!!utils.get(this.state.errorsOnSave, 'username')}/>
                            </div>




                            <div className="form-group leumit-login-form-group">
                                <button className="sade-login-form-button"
                                        onClick={this.onSubmit.bind(this)}>{t('defaults.rst_pwd.rst_pwd')}</button>
                            </div>
                        </div>
                    </div>
                    <div className={'leumit-login-form-group loginError red h-centered'}>
                        <Error isNonFloat={true}
                               errorMessage={t('defaults.rst_pwd.auth_err') + ': ' + this.state.errMessage}
                               isShown={this.state.isErr}/>
                    </div>
                    <div className={'leumit-login-footer-container2'}
                         onClick={() => this.goBack()}>
                        <a>{t('defaults.rst_pwd.back_to_login')}</a>
                    </div>
                </div>

                <div className={'login-version-element'}>
                        <div className={'login-version-element-label'}>Version:</div>
                        <div className={'login-version-element-value'}>{Config.version} {Config.build}</div>
                    </div>
                <div className={'recaptcha-block'}>
                    <ReCaptcha setRef={ref => (this.recaptchaRef = ref)}
                               action={async (reCaptchaToken) => {
                                   await this.submitData(reCaptchaToken);
                               }}
                        /*setErr={ this.setRecapchaErrors()}*//>
                </div>

            </div>

        )
    }
}

let ResetPassword = compose(
    withTranslation()
)(ResetPasswordComposed)

export default ResetPassword;
